var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlayinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 30,
    viewBox: "0 0 24 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.14 13.26L2.253.204a1.302 1.302 0 00-.766-.202 1.349 1.349 0 00-.748.29 1.832 1.832 0 00-.541.706A2.34 2.34 0 000 1.945v26.11c0 .332.069.658.198.947.13.29.315.533.541.707.226.175.483.274.748.289.265.015.529-.055.766-.203L23.14 16.742c.258-.162.476-.41.627-.718.152-.307.233-.661.233-1.023 0-.361-.08-.715-.233-1.023a1.752 1.752 0 00-.627-.718z",
    fill: "#fff"
  })));
}

export default SvgPlayinline;